import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "@/lang";
import { PHONE, PHONE_TEL, EMAIL } from "@/content";

export default function Footer() {
    const { c } = useLang();
    const links = [
        { to: "/", label: c.nav.home, id: "home" },
        { to: "/about", label: c.nav.about, id: "about" },
        { to: "/products", label: c.nav.products, id: "products" },
        { to: "/career", label: c.nav.career, id: "career" },
        { to: "/contact", label: c.nav.contact, id: "contact" },
    ];

    return (
        <footer className="relative overflow-hidden border-t border-line bg-pure">
            <div className="container-x grid gap-12 py-16 md:grid-cols-12 md:py-20">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-4">
                    <Logo variant="dark" className="h-11 w-auto sm:h-12" />
                </div>
                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">
                        {c.footer.blurb}
                    </p>
                    <div className="mt-6 flex flex-col gap-3">
                        <a
                            href={`tel:${PHONE_TEL}`}
                            data-testid="footer-phone-link"
                            className="flex items-center gap-3 text-lg font-medium text-ink transition-colors hover:text-sky-text"
                        >
                            <Phone className="h-4 w-4 text-sky-text" />
                            {PHONE}
                        </a>
                        <a
                            href={`mailto:${EMAIL}`}
                            data-testid="footer-email-link"
                            className="flex items-center gap-3 font-mono text-sm text-mist transition-colors hover:text-sky-text"
                        >
                            <Mail className="h-4 w-4 text-sky-text" />
                            {EMAIL}
                        </a>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-mist">
                        {c.footer.navTitle}
                    </h4>
                    <ul className="mt-5 space-y-3">
                        {links.map((l) => (
                            <li key={l.id}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-nav-link-${l.id}`}
                                    className="text-base font-medium text-ink-soft transition-colors hover:text-sky-text"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-mist">
                        {c.footer.hoursTitle}
                    </h4>
                    <ul className="mt-5 space-y-2" data-testid="footer-markets-list">
                        {c.contact.area.map((line, i) => (
                            <li key={i} className="font-mono text-sm leading-relaxed text-mist">
                                {line}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-6 inline-flex items-center gap-2.5 rounded-full border border-line px-4 py-2">
                        <span className="h-2 w-2 animate-pulse-dot rounded-full bg-sky-text" />
                        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-soft">
                            {c.contact.status}
                        </span>
                    </div>
                </div>
            </div>

            <div className="pointer-events-none select-none px-5 sm:px-8 lg:px-10" aria-hidden="true">
                <p className="text-outline whitespace-nowrap text-center font-display text-[11vw] font-extrabold leading-[0.8] tracking-tight opacity-70">
                    STAR USA
                </p>
            </div>

            <div className="border-t border-line">
                <div className="container-x flex flex-col items-start justify-between gap-2 py-5 font-mono text-[10px] uppercase tracking-[0.18em] text-mist sm:flex-row sm:items-center">
                    <span dangerouslySetInnerHTML={{ __html: c.footer.license }} />
                    <span dangerouslySetInnerHTML={{ __html: `© ${new Date().getFullYear()} ` + c.footer.rights }} />
                </div>
            </div>
        </footer>
    );
}
